import React from "react";
import "./../../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../../Styles/app.css";
import "./Styles/style.css";
import "./Styles/theme-responsive.css";
import { connect } from "react-redux";
import i18n from "i18next";
import {
	RegisterFooter,
	RegisterHeader,
	RegisterWizard,
	SubmitButton,
} from "../../CommonComponents";
import "../../../../node_modules/font-awesome/css/font-awesome.min.css";
import {
	saveRegistrationInfo,
	checkUserEmail,
	checkUserEmailClear,
	startUserRegistration,
	startRegistrationClear,
	setEnvironment,
	showModal, hideModal, setHelpList
} from "../../../common/actions/userAccount";

import { BootstrapModal } from "../../CommonComponents";
import GLOBAL_CONST from '../../../helper/AppConstants';

import { createLoadingSelector } from "../../../common/reducers/selectors";
import { withTranslation } from "react-i18next";
import { getLanguageCode } from "../../../helper/utility";
const loadingSelector = createLoadingSelector([
	"check_email",
	"start_registartion",
]);

class RegisterEmail extends React.Component {
	constructor(props) {
		super(props);
		const { registeredEmail } = this.props
		this.state = {
			email: registeredEmail ? registeredEmail : '',
			emailInvalid: "",
		};
		this.dosetHelpList()
	}


	dosetHelpList = () => {
		this.props.dosetHelpList({
			stackType: "Registration",
			screen: GLOBAL_CONST.SCREEN_NAMES.REGISTRATION_EMAIL,
			title: this.props.t('regCardScr-regAccount'),
		});
	}
	openHelpModal = () => {
		this.props.doShowModal({
			modalScreenName: "HelpListing",
			modalClassName: "helpSupportModal sidebar-modal right",
			params: {
				stackType: this.props.setHelpListData.stackType,
				screen: this.props.setHelpListData.screen,
				title: this.props.setHelpListData.title,
			}
		});
	}

	handleEmailChange = ({ target: { value: email } }) =>
		this.setState({ email, emailInvalid: "" });

	submitForm = () => {
		let { env } = this.state;
		const { email } = this.state;
		var reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

		let isValid = reg.test(email);
		if (reg.test(email) === false) {
			this.setState({
				emailInvalid: `${this.props.t("regAcctScr-emailError")}`,
			});
			return;
		}
		if (email.endsWith(".con")) {
			this.setState({
				emailInvalid: `${this.props.t("regAcctScr-emailError")}`,
			});
			return;
		}

		if (email.includes(".staging")) {
			env = "staging";
		} else if (email.includes(".develop")) {
			env = "develop";
		} else if (email.includes(".localhost")) {
			env = "localhost";
		} else {
			env = "prod";
		}
		const { doSetEnvironment } = this.props;
		this.setState({ env }, () => {
			if (env === "staging") {
				doSetEnvironment({
					env: "staging",
					callback: this.doCheckEmailProcess,
				});
			} else if (env === "develop") {
				doSetEnvironment({
					env: "develop",
					callback: this.doCheckEmailProcess,
				});
			} else if (env === "localhost") {
				doSetEnvironment({
					env: "localhost",
					callback: this.doCheckEmailProcess,
				});
			} else {
				doSetEnvironment({ env: "prod", callback: this.doCheckEmailProcess });
			}
		});
	};
	doCheckEmailProcess = () => {
		const { doCheckEmail } = this.props;
		let { email } = this.state;
		if (email.includes(".staging")) {
			email = email.replace(".staging", "");
		}else if (email.includes(".develop")) {
			email = email.replace(".develop", "");
		}else if (email.includes(".localhost")) {
			email = email.replace(".localhost", "");
		}

		doCheckEmail({ Email: email, locale: getLanguageCode() });
	};
	doRegistration = () => {
		const {
			registeredFirstname,
			registeredLastname,
			dostartUserRegistration,
		} = this.props;

		let { email } = this.state;
		if (email.includes(".staging")) {
			email = email.replace(".staging", "");
		}else if (email.includes(".develop")) {
			email = email.replace(".develop", "");
		}else if (email.includes(".localhost")) {
			email = email.replace(".localhost", "");
		}

		dostartUserRegistration({
			Firstname: registeredFirstname,
			Lastname: registeredLastname,
			Email: email,
			Locale: getLanguageCode()
		});
	};

	componentDidUpdate() {
		const { email } = this.state;
		const {
			checkEmailResponse,
			error,
			doCheckEmailClear,
			registartionResponse,
			dostartRegistrationClear,
			doSaveRegistrationInfo,
		} = this.props;

		if (error) {
			this.setState({ emailInvalid: error.Message });
			doCheckEmailClear();
		} else if (checkEmailResponse) {
			doCheckEmailClear();
			this.doRegistration();
		} else if (registartionResponse) {
			doSaveRegistrationInfo({
				registeredEmail: email,
				registeredResultCache: registartionResponse,
			});
			this.props.history.push("/confirmEmail");
			dostartRegistrationClear();
		}
	}

	render() {
		const { email, emailInvalid } = this.state;
		const { isFetching } = this.props;
		return (
			<section className="registration">
				<div className="wrapper">
					<div className="landing-wrapper">
						<div className="row h-100vh nomargin-row">
							<RegisterHeader />
							<div className="col-sm-12 col-md-5 col-lg-5 col-xl-4 sidebar-col">
								<div className="sidebar-wrapper">
									<form className="form-style1" onSubmit={(e) => { e.preventDefault() }}>
										<RegisterWizard webPage={this.props.location.pathname} />
										<div className="title-sect mb-40">
											<h3 className="title-3">
												{this.props.t("regAcctScr-yourEmail")}
											</h3>
											<p className="helptext">
												{this.props.t("regAcctScr-enterEmail")}
											</p>
										</div>
										<div className="form-group">
											<input
												type="text"
												className={`form-control ${emailInvalid !== "" ? "input-error" : null
													}`}
												placeholder={this.props.t("regAcctScr-emailAddrs")}
												value={email}
												onChange={this.handleEmailChange}
												name="email"
												onKeyPress={(event) => { if (event.key === 'Enter') this.submitForm(); }}
											/>
											<span className="error" id="message">
												{" "}
												{emailInvalid}
											</span>
										</div>

										<div className="form-group mb-40">
											<button type="button" className="btn needhelp-label"
												onClick={() => {
													this.openHelpModal();
												}}

											>
												{this.props.t("regNameScr-needHelp")}
											</button>
										</div>
										<SubmitButton
											nextAction={() => {
												this.submitForm();
											}}
											loading={isFetching}
										/>
									</form>
									<RegisterFooter />
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		);
	}
}

function mapStateToProps(state) {
	return {
		registeredEmail: state.userAccount.registeredEmail,
		registeredFirstname: state.userAccount.registeredFirstname,
		registeredLastname: state.userAccount.registeredLastname,
		isFetching: loadingSelector(state),
		checkEmailResponse: state.userAccount.checkEmailResponse,
		registeredResultCache: state.userAccount.registeredResultCache,
		registartionResponse: state.userAccount.registartionResponse,
		error: state.userAccount.error,
		verifiedEmail: state.userAccount.verifiedEmail,
		setHelpListData: state.userAccount.setHelpListData,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		doSaveRegistrationInfo: (data) => dispatch(saveRegistrationInfo(data)),
		doCheckEmail: (data) => dispatch(checkUserEmail(data)),
		doCheckEmailClear: () => dispatch(checkUserEmailClear()),
		dostartUserRegistration: (data) => dispatch(startUserRegistration(data)),
		dostartRegistrationClear: () => dispatch(startRegistrationClear()),
		doSetEnvironment: (data) => dispatch(setEnvironment(data)),

		dosetHelpList: (data) => dispatch(setHelpList(data)),
		doShowModal: (data) => dispatch(showModal(data)),
		doHideModal: () => dispatch(hideModal()),


	};
}
export default withTranslation()(
	connect(mapStateToProps, mapDispatchToProps)(RegisterEmail)
);
